/* global window:true */
/* eslint no-underscore-dangle: 0 */

import appReducer from './app';
import { createStore, combineReducers, compose } from 'redux'
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase'
import firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyCWOFVkaxvYNzkabjm6ziHybYtmxNH5gzw",
  authDomain: "parkyou-1.firebaseapp.com",
  databaseURL: "https://parkyou-1-landing.firebaseio.com",
  projectId: "parkyou-1",
  storageBucket: "parkyou-1.appspot.com",
  messagingSenderId: "529103120846"
}

// initialize firebase instance
firebase.initializeApp(firebaseConfig)

// react-redux-firebase config
const rrfConfig = {
  // useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
}

// Add reactReduxFirebase enhancer when making store creator
const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, rrfConfig), // firebase instance as first argument
  // reduxFirestore(firebase) // <- needed if using firestore
)(createStore)

// Add firebase to reducers
const rootReducer = combineReducers({
  firebase: firebaseReducer,
  app: appReducer
  // firestore: firestoreReducer // <- needed if using firestore
})

export default () => {
  const devtools =
    process.env.NODE_ENV === 'development' && window.devToolsExtension
      ? window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f;
  return createStoreWithFirebase(rootReducer, {});
};



// WEBPACK FOOTER //
// ./src/state/createStore.js